import React from 'react';

import './dataGrid.header.scss';

export const DataGridBody = ({ children }) => (
  <tbody className="data-grid__body">{children}</tbody>
);
